// Replaces the Krajee bootstrap-fileinput plugin: a Browse button, the chosen
// file's name, an image preview and the same client-side size/type checks.
// Hooks are the class names the views already give their file inputs.
const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];

const rules = [
  ['.fileinput-cv', { preview: false, maxSizeKb: 1000, extensions: ['doc', 'docx', 'pdf', 'rtf', 'txt'] }],
  ['.fileinput-logo', { preview: true, extensions: imageExtensions }],
  ['.Fileinput', { preview: true, maxSizeKb: 1000, extensions: imageExtensions }],
  ['.fileinput', { preview: true }],
];

function validate(file, { maxSizeKb, extensions }) {
  const extension = file.name.split('.').pop().toLowerCase();

  if (extensions && !extensions.includes(extension)) {
    return `"${file.name}" isn't an allowed file type. Use ${extensions.join(', ')}.`;
  }

  if (maxSizeKb && file.size > maxSizeKb * 1024) {
    return `"${file.name}" is ${Math.ceil(file.size / 1024)} KB; the limit is ${maxSizeKb} KB.`;
  }

  return null;
}

function enhanceFile(input, options) {
  if (input.dataset.enhanced) {
    return;
  }

  input.dataset.enhanced = 'true';

  if (options.extensions && !input.accept) {
    input.accept = options.extensions.map((extension) => `.${extension}`).join(',');
  }

  const picker = document.createElement('div');
  picker.className = 'file-picker';
  picker.innerHTML = `
    <div class="flex flex-wrap items-center gap-3">
      <label class="button button-secondary mb-0 cursor-pointer has-focus-visible:outline-2 has-focus-visible:outline-offset-2 has-focus-visible:outline-brand">
        <svg class="size-4" aria-hidden="true"><use href="/dist/icons.svg#arrow-up-tray"></use></svg>
        <span>Browse…</span>
      </label>
      <span class="file-picker-name min-w-0 truncate text-sm text-slate-600">No file chosen</span>
      <button type="button" class="file-picker-clear link-button text-sm text-brand-accent" hidden>Remove</button>
    </div>
    <img class="file-picker-preview mt-3 max-h-40 rounded-md border border-slate-200 bg-white p-1" alt="" hidden>
    <p class="file-picker-error field-validation-error mt-2 mb-0 text-sm" role="alert" hidden></p>`;

  input.replaceWith(picker);
  input.classList.add('sr-only');
  picker.querySelector('label').append(input);

  const name = picker.querySelector('.file-picker-name');
  const clear = picker.querySelector('.file-picker-clear');
  const preview = picker.querySelector('.file-picker-preview');
  const error = picker.querySelector('.file-picker-error');

  const reset = () => {
    input.value = '';
    name.textContent = 'No file chosen';
    clear.hidden = true;
    preview.hidden = true;
    preview.removeAttribute('src');
  };

  input.addEventListener('change', () => {
    const [file] = input.files;
    error.hidden = true;

    if (!file) {
      reset();
      return;
    }

    const problem = validate(file, options);

    if (problem) {
      reset();
      error.textContent = problem;
      error.hidden = false;
      return;
    }

    name.textContent = file.name;
    clear.hidden = false;

    if (options.preview && file.type.startsWith('image/')) {
      preview.src = URL.createObjectURL(file);
      preview.hidden = false;
    }
  });

  clear.addEventListener('click', reset);
}

export function enhanceFiles(root = document) {
  for (const [selector, options] of rules) {
    root.querySelectorAll(`input[type=file]:is(${selector})`).forEach((input) => enhanceFile(input, options));
  }
}
